module.exports = __webpack_public_path__ + "img/page27am42small_dutchamigamagazine.d2085f8e.png";